import { ChevronDown } from 'lucide-react';
import { cn } from '../../utils';

const AnimatedIcon = ({
  isOpen = false,
  className,
  iconClassName,
  onClick,
}: {
  isOpen?: boolean;
  className?: string;
  iconClassName?: string;
  //
  onClick?: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      className={cn('animated', isOpen ? 'rotate-180' : 'rotate-0', className)}
    >
      <ChevronDown className={cn('w-6 h-6 text-labelText', iconClassName)} />
    </div>
  );
};

export default AnimatedIcon;
